import { render, staticRenderFns } from "./abModal.vue?vue&type=template&id=0bfb289e&scoped=true&"
import script from "./abModal.vue?vue&type=script&lang=js&"
export * from "./abModal.vue?vue&type=script&lang=js&"
import style0 from "./abModal.vue?vue&type=style&index=0&id=0bfb289e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb289e",
  null
  
)

export default component.exports